import styled from 'styled-components';



export const ReviewPageBgWrapper = styled.section`
  background: #2276e3;
  width: 100%;
  height: 19rem;
  display: flex;
`;
export const HeaderWrapper = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  position: relative;
`;
export const PageHeader = styled.header(
  props => `
    font-size: 2.2rem;
    color: white;
    font-weight: bold;
    font-family:${props.theme.font.fontFamily};
    padding: 2rem 0;
`,
);
export const BookingHeader = styled(PageHeader)`
  span {
    font-weight: normal;
  }
`;
export const HeaderInfo = styled.div(
  props => `
    padding-left: 1rem;
    padding-top: 9.5rem;
    display: flex;
    span {
        font-family:${props.theme.font.fontFamily};
        color: white;
        font-size: 1.6rem;
        font-weight: bold;
        padding-left: 1rem;
    }
`,
);

export const PageWrapper = styled.section`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: -5rem;
`;
export const LeftWrapper = styled.section`
  width: 100%;
  max-width: 793px;
`;
export const RightWrapper = styled.section`
  width: 100%;
  max-width: 387px;
  
`;
export const ReviewCardWrap = styled.section`
  margin-top: 1.5rem;
`;







export const ReviewCard = styled.section`
  background: white;
  border-radius: 0.4rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

export const TabContent = styled.div`
  padding: 2rem;
`;

export const TabLabel = styled.label(
  props => `
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 2rem;
      cursor: pointer;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      
  `,
);

export const ContentRow = styled.div`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
`
export const ContentInner = styled.div`
      border: 1px solid #e5e5e5;
      display: flex;
      flex-direction: column;
      padding: 1rem;
      border-radius: 0.5rem;
      margin-bottom: 1rem;
`

export const BookingDetailCard = styled.div`
      display: flex;
      flex-direction: row;
      
`
export const DetailCard = styled.div`
      background: white;
      border-radius: 0.4rem;
      width: 50%;
      margin-bottom: 1.5rem;
      padding: 2rem;
`